import React from 'react';
import {
  Box,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Divider,
  useDisclosure,
  Button,
  Text,
  Link,
  Flex,
  Center,
} from '@chakra-ui/react';
// import ProjectItem from "../projectItem";
import ProjectItem from '../projectItem';
import 'react-awesome-slider/dist/styles.css';
import MetamediaMapTour from './metamedia-map-tour';
import '../styles/spec-list.css';
import { RiComputerLine } from 'react-icons/ri';
import { PiDotOutlineLight } from 'react-icons/pi';
const TOOL_GROUPS = [
  {
    title: 'Front-End Development',
    items: [
      ['Frameworks', 'Vue.js, Nuxt.js'],
      ['Languages & Markup', 'JavaScript, HTML'],
      ['Design & Collaboration', 'UX/UI Design, Figma'],
    ],
  },
  {
    title: 'Back-End & Server-Side',
    items: [
      ['Programming Languages', 'Go (Golang), PHP, Python, JavaScript'],
      ['Runtimes & Platforms', 'Node.js, Drupal'],
      ['Query Language', 'SQL'],
    ],
  },
  {
    title: 'DevOps, Tools & Infrastructure',
    items: [
      ['Containerization', 'Docker'],
      ['Version Control', 'Git'],
      ['Authentication', 'Keycloak'],
      ['APIs & Integration', 'Line Develop'],
      ['GIS Solutions', 'Longdo Map'],
    ],
  },
  {
    title: 'Testing & Quality Assurance',
    items: [
      ['E2E Testing', 'Cypress.js'],
      ['Unit Testing', 'Vitest'],
    ],
  },
];

export default function Project2() {
  const title = 'Senior Software Developer';
  const subtitle = 'Metamedia Technology Co., Ltd.';
  const { isOpen, onOpen, onClose } = useDisclosure();
  const calculateDateDifference = (date1, date2) => {
    var diffMonths =
      date2.getMonth() -
      date1.getMonth() +
      12 * (date2.getFullYear() - date1.getFullYear());
    var years = Math.floor(diffMonths / 12);
    var months = diffMonths % 12;

    return `( ${years} years ${months} months )`;
  };

  return (
    <div>
      <div className="card-container" onClick={onOpen}>
        <ProjectItem
          title={title}
          subtitle={subtitle}
          tags={['Vue.js', 'Nuxt.js', 'Node.js', 'PHP']}
        />
      </div>

      <Modal
        onClose={onClose}
        size={{ base: 'full', lg: '4xl' }}
        isOpen={isOpen}
        scrollBehavior={'inside'}
        isCentered
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader pb={4}>
            {title}
            <Box className="eyebrow" mt={1}>
              {subtitle}
            </Box>
            <Divider mt={4} />
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {/* <Slider/> */}
            <Box>
              <Text className="modal-copy">
                Developed dynamic and responsive front-end applications using
                Vue.js, Nuxt.js, HTML, CSS, and JavaScript, ensuring precise
                alignment with client specifications and design layouts.
                Architected scalable, multi-technology backend services
                leveraging Go, Node.js, and PHP (Drupal), successfully
                optimizing data storage and retrieval for high-speed, reliable
                operations.
              </Text>
            </Box>
            <Box mt={6}>
              <Text className="modal-copy">
                Ensured application stability and integrity by leading
                end-to-end (E2E) automation testing with Cypress.js and
                implementing unit testing protocols using Vitest. Integrated
                proprietary GIS solutions, specifically the Longdo Map product,
                to fulfill complex client requirements, including the successful
                deployment for projects like Loykrathong, Map Game.
              </Text>
            </Box>
            <Box mt={6}>
              <Text className="modal-copy">
                Streamlined development and deployment workflows by utilizing
                version control (Git), authentication systems (Keycloak), and
                design collaboration tools (Figma).
              </Text>
            </Box>
            <Box className="eyebrow" mt={12} mb={3}>
              WHERE THE WORK HAPPENED
            </Box>
            <Box mt={4} h={{ base: '420px', md: '500px' }}>
              <MetamediaMapTour />
            </Box>
            <Box className="eyebrow" mt={12} mb={6}>
              TOOLS
            </Box>
            <div className="spec-grid">
              {TOOL_GROUPS.map(group => (
                <div className="spec-group" key={group.title}>
                  <div className="spec-group__title">{group.title}</div>
                  <dl className="spec-list">
                    {group.items.map(([label, value]) => (
                      <div className="spec-row" key={label}>
                        <dt className="spec-row__label">{label}</dt>
                        <dd className="spec-row__value">{value}</dd>
                      </div>
                    ))}
                  </dl>
                </div>
              ))}
            </div>

            <Box className="eyebrow" mt={12} mb={3}>
              WORKING PERIOD
            </Box>
            <Flex mt={3}>
              <Center gap={2}>
                <Box fontFamily="mono" fontSize={13}>
                  Jun 2021 — Present
                </Box>
                <PiDotOutlineLight />
                <Box fontFamily="mono" fontSize={13} color="ink-dim">
                  {calculateDateDifference(new Date('2021-06-16'), new Date())}
                </Box>
              </Center>
            </Flex>
            <Box className="eyebrow" mt={12} mb={3}>
              COMPANY
            </Box>
            <Box mt={3}>
              <Link href="https://www.mm.co.th/" target="_blank">
                <Button colorScheme="brand" variant="outline">
                  {subtitle}
                </Button>
              </Link>
            </Box>
            <Center mt={12}>
              <Divider mr={5} />
              <RiComputerLine size={50} />
              <Divider ml={5} />
            </Center>
          </ModalBody>
          {/* <Box px={6}>
            <Divider mt={12} mb={6} />
          </Box> */}
        </ModalContent>
      </Modal>
    </div>
  );
}
